export default {
    "首页": "HOME",
    "发现": "DISCOVER",
    "频道": "CHANNEL",
    "学习": "LEARN",
    "活动": "ENENT",
    "项目": "PROJECT",
    "更多": "MORE",
    "发布": "PUBLISH"
}


// WEBPACK FOOTER //
// ./src/languages/en/header.js